import { AttributeFilter } from 'app/shared/ui/models/attribute-filter';

export class StringAttributeFilter implements AttributeFilter {
  attribute: string;
  label: string;
  operator: string;
  value?: string;
  tempValue?: string | undefined;
  secondValue?: any;

  constructor(attribute: string, label: string, operator: string, value?: string, secondValue?: any) {
    this.attribute = attribute;
    this.label = label;
    this.operator = operator;
    this.value = value;
    this.secondValue = secondValue;
  }

  updateValue(): unknown {
    const filters = Object.create({});
    this.value = this.tempValue;
    filters[this.attribute + '.' + this.operator] = this.value;
    return filters;
  }

  isChecked(): boolean {
    if (this.tempValue) {
      return true;
    }
    return false;
  }

  htmlButtonText(): string {
    let htmlContent = '<b>' + this.label + '</b> ';
    if (this.operator === 'contains') {
      htmlContent += 'contient';
    } else if (this.operator === 'equals') {
      htmlContent += 'est exactement';
    } else if (this.operator === 'doesNotContain') {
      htmlContent += 'ne contient pas';
    } else {
      htmlContent += '';
    }
    htmlContent += ' <b>' + this.value + '</b>';
    return htmlContent;
  }
}
